import { Box, Text } from "@chakra-ui/react"
import { Toggle, Toggles } from "@hydrologiq/schemas/1.0.0/installationPage"
import { Switch } from "@hydrologiq/shared/chakra/Switch"
import { useState } from "react"

export interface ConfigureTogglesProps {
  toggles: Toggles
  changeCallback?: (toggles: Toggles) => void
  comparisonLabel?: string
}

function ConfigureToggles({ toggles, changeCallback = () => {}, comparisonLabel }: ConfigureTogglesProps) {
  const [useToggles, setUseToggles] = useState<Toggles>(structuredClone(toggles))
  const changeToggle = (checked: boolean, name: string) => {
    const toggles = structuredClone(useToggles)
    if (Object.keys(toggles).includes(name)) (toggles as Record<string, Toggle>)[name].status = checked
    setUseToggles(toggles)
    changeCallback(toggles)
  }
  const label = comparisonLabel ? comparisonLabel : "peak"
  return (
    <>
      {useToggles.peak && (
        <Box display="flex" alignItems="center" mb={2} gap={"10px"}>
          <Text mb={0}>Show {label}</Text>
          <Switch
            mt={1}
            onCheckedChange={(e) => changeToggle(e.checked, "peak")}
            defaultChecked={useToggles.peak?.status}
            inputProps={{
              "aria-label": `Show ${label}`,
            }}
          />
        </Box>
      )}
    </>
  )
}

export default ConfigureToggles
